/* tslint:disable */
/* eslint-disable */
/**
 * Agora Livestock API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0.0 (v2)
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * * `date_delivery` - Delivery Date * `date_kill` - Kill Date * `date_transport` - Transport Date
 * @export
 * @enum {string}
 */
export enum FieldsSystemEnum {
    Delivery = 'date_delivery',
    Kill = 'date_kill',
    Transport = 'date_transport'
}



